import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { StorageComponent } from './storage.component';
import { RouterModule } from '@angular/router';
import { StoragesService } from './storage.service';
import { MatButtonModule } from '@angular/material/button';
import { MatTableModule } from '@angular/material/table';
import { MatPaginatorModule } from '@angular/material/paginator';
import { CdkTableModule } from '@angular/cdk/table';
import { MatIconModule } from '@angular/material/icon';
import { PipesModule } from 'src/app/pipes/pipes.module';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatSortModule } from '@angular/material/sort';
import { StorageStatsComponent } from './storage-stats/storage-stats.component';
import { MatCardModule } from '@angular/material/card';
import { StorageConfirmationModalComponent } from './storage-confirmation-modal/storage-confirmation-modal.component';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { FormsModule } from '@angular/forms';

@NgModule({
  declarations: [StorageComponent, StorageStatsComponent, StorageConfirmationModalComponent],
  imports: [
    CommonModule,
    RouterModule,
    MatIconModule,
    MatButtonModule,
    MatTableModule,
    MatPaginatorModule,
    CdkTableModule,
    PipesModule,
    MatTooltipModule,
    MatSortModule,
    MatCardModule,
    MatDialogModule,
    MatInputModule,
    MatFormFieldModule,
    FormsModule
  ],
  providers: [StoragesService],
  exports: [StorageComponent, MatTableModule]
})
export class StorageModule {}
